import clipboard from 'react-use-clipboard';

export const useClipboard = clipboard;